import { combineTokens } from '@utils/css';

const tokens = combineTokens("--dropzone", {
  left: "0%",
  top: "0%",
  width: "0%",
  height: "0%",
  maskSrc: ""
});
const emptyDropzone = "_35se11msr0x";
const placeholder = "_35sp18cdvhr";

export { emptyDropzone, placeholder, tokens };
import "./atom.empty.style.linaria.module.css";
//# sourceMappingURL=atom.empty.style.js.map
